import { api, ApiError } from "@/api/client"
import { useMutation } from "@tanstack/react-query"
import { TokensResponse } from "../../../../backend/src/routes/schemes"
import { useResponseNotification } from "@/hooks/useResponseNotification"
import { AxiosError } from "axios"

export const personificateUserRequest = async (token: string | undefined, userId: number) => {
    const { data } = await api({ token }).post<TokensResponse>(`/auth/personification`, { userId })
    return data
}

export const usePersonificateUserMutation = (token: string | undefined) => {
    const { handleErrorResponse } = useResponseNotification()
    return useMutation<TokensResponse, AxiosError<ApiError>, number>({
        mutationFn: (userId: number) => personificateUserRequest(token, userId),
        onError: (error) => handleErrorResponse(error),
    })
}
